import { useCallback } from "react";
import useProfiler from "../../../hooks/useProfiler";
import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_pc_loading_steps_desktop",
  stages: {
    users_clicked_pay: 1, // Main stage - users who clicked pay
    agency: 6,
    merchant: 7
  },
  defaultStage: 1,
  goals: {
    price_change_error_exists: 1,
    payment_error_exists: 2,
    booking_failed: 3
  }
});

const { stages, goals } = utils;

export const useTrackPaymentComponentLoadingSteps = () => {
  const { isDesktop } = useProfiler();

  const trackPcLoadingClientAndSupplierType = useCallback(
    (supplierType?: string) => {
      if (!isDesktop()) return;

      supplierType === "MERCHANT" && stages.merchant();
      supplierType === "AGENCY" && stages.agency();
    },
    [isDesktop]
  );

  const trackPriceChangeErrorExists = useCallback(() => {
    if (!isDesktop()) return;

    goals.price_change_error_exists();
  }, [isDesktop]);

  const trackPaymentErrorExists = useCallback(() => {
    if (!isDesktop()) return;

    goals.payment_error_exists();
  }, [isDesktop]);

  const trackBookingFailed = useCallback(() => {
    if (!isDesktop()) return;

    goals.booking_failed();
  }, [isDesktop]);

  return {
    trackPcLoadingClientAndSupplierType,
    trackPriceChangeErrorExists,
    trackPaymentErrorExists,
    trackBookingFailed
  };
};

export default utils;
